const formFields = document.querySelectorAll('select');

for (let i = 0; i < formFields.length; i++) {
	const field = formFields[i];

	field.addEventListener('focus', () => {
		field.classList.add('active');
	});

	field.addEventListener('blur', () => {
		field.classList.remove('active');
	});

	field.addEventListener('change', () => {
		if (field.classList.contains('active')) {
			field.blur();
		}

		// Custom style if empty
		if (field.value === '') {
			field.classList.add('is-empty');
		} else {
			field.classList.remove('is-empty');
		}
	});

	// Custom style if empty
	if (field.value === '') {
		field.classList.add('is-empty');
	} else {
		field.classList.remove('is-empty');
	}
}
